import * as yup from 'yup';

import { parseDate } from '../../dates/parseDate';
import { dateFormatter } from '../../formatters/dateFormatter';
import { DateTypeBase } from '../../baseTypes/DateTypeBase';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_TIME } from '../constants';

export class DateTimeType extends DateTypeBase {
  group = TYPE_GROUP_TIME;

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Data,
    TypeContextEnum.Properties,
    TypeContextEnum.Metatag,
  ];

  name = 'DateTime';

  friendlyName = 'Date & Time';

  get example() {
    return new Date();
  }

  get default(): any {
    return new Date();
  }

  formatter = (date: any, opts: any) =>
    dateFormatter(date, 'yyyy-MM-dd h:mm a', opts?.timeZone);

  buildSchema() {
    return yup.date().nullable();
  }

  parseValue = (value: any) => parseDate(value);
}

const definition = new DateTimeType();

Types.addBaseType(definition);
export { definition as DateTimeDefinition };
